import { inject, Injector, Signal, TemplateRef } from '@angular/core';
import { Dismissed, ResolvableModalConfig } from '../types/modal-config';
import { ModalService } from '../modal.service';
import { DateRange } from '../types/date-range';
import { DateRangePickerModalComponent } from '../components/date-range-picker-modal/date-range-picker-modal.component';

export interface DateRangeModalConfig2 {
  title?: string | Signal<string | null>;
  subtitle?: string | Signal<string | null>;
  content?: TemplateRef<any> | Signal<TemplateRef<any> | null>;
  contentContext?: object | Signal<object | null>;
  text?: string | Signal<string>;
  showCancel?: boolean;
  class?: string;
  value?: DateRange | null;
  shortcuts?: { value: DateRange; label: string }[] | null;
  dismiss?: boolean;
}

async function selectDateRange(
  modalService: ModalService,
  config: DateRangeModalConfig2,
  injector: Injector
): Promise<DateRange | null | Dismissed> {
  const modalConfig: ResolvableModalConfig<DateRangePickerModalComponent, DateRange | null> = {
    component: DateRangePickerModalComponent,
    dismiss: true,
    title: config.title ?? 'Datum asuwählen',
    subtitle: config.subtitle,
    text: config?.text,
    priority: Number.POSITIVE_INFINITY,
    data: {
      title: config?.title ?? undefined,
      subtitle: config?.subtitle ?? undefined,
      value: config?.value ?? null,
      shortcuts: config?.shortcuts ?? null,
    },
    class: config.class,
    injector: injector,
  };

  return await modalService.open(modalConfig);
}

export function selectDateRangeFn(): (
  config: DateRangeModalConfig2
) => Promise<DateRange | null | Dismissed> {
  const modalService = inject(ModalService);
  const injector = inject(Injector);
  return (config) => selectDateRange(modalService, config, injector);
}
